import { linkToEpocusReviewEncounter, linkToEpocusReviewPanel } from "../links";

export const linkToReviewQueueEntry = (
  encounterId: string,
  exams: readonly { id: string }[],
): string => {
  const [onlyExam] = exams;
  return exams.length === 1 && onlyExam
    ? linkToEpocusReviewPanel(onlyExam.id)
    : linkToEpocusReviewEncounter(encounterId);
};
